var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('home-menu'),_vm._v(" "),_c('announcement'),_vm._v(" "),_c('news'),_vm._v(" "),_c('cartableGrid')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }